export const API_ENDPOINTS = {
  LOGIN: "/users/login",
  REGISTER: "/users/register",
  GET_PROFILE: "/users/profile",
  FORGOT_PASSWORD: "/users/forgot-password",
  RESET_PASSWORD: "/users/reset-password",
  UPDATE_PROFILE: "/users/profile",
};

export const APP_ROUTES = {
  DASHBOARD: "/dashboard",
  LOGIN: "/login",
  REGISTER: "/register",
  PROFILE: "/profile",
  ANALYTICS: "/analytics",
  TASKS: "/tasks",
  SETTINGS: "/settings",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  HOME: "/home",
  SUBSCRIBED_LOCATIONS: "/subscribed-locations",
  INVOICE_LIST: "/invoice-list",
  // ADD_SUBACCOUNT: "/add-subaccount",
  AUTH_SUCCESS: "/auth-success",
  QR_SCAN: "/qr-scan",
  PAYMENT_SUCCESS: "/payment-success",
  PAYMENT_FAILED: "/payment-failed",
  FAQ: "/faq",
};
